import { PropsWithChildren } from 'react'

type Props = {
  className?: string
}

const CourseEditorBox = ({ children, className }: PropsWithChildren<Props>) => {
  return (
    <div
      className={`${
        className || ''
      } mb-2 rounded border border-solid border-gray-300 px-6 py-4 text-base shadow-md`}
    >
      {children}
    </div>
  )
}

export default CourseEditorBox
